const filterListModalfilterUser = {
  filter: 'FILTROS',
  clear: 'limpar filtros'
};

export default filterListModalfilterUser;
